import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaTruck } from 'react-icons/fa';

export default function RentalButton({ scrollProgress = 0, fullWidth = false }) {
  return (
    <Link
      to="/rental"
      className={`group relative px-6 py-2 rounded-full font-medium transition-all duration-300 hover:-translate-y-0.5 ${
        fullWidth ? 'w-full flex justify-center' : 'inline-flex'
      }`}
      style={{
        background: scrollProgress > 0
          ? 'linear-gradient(to bottom right, rgb(220, 38, 38), rgb(185, 28, 28))'
          : 'rgb(220, 38, 38)',
        color: 'white',
        boxShadow: scrollProgress > 0
          ? '0 10px 15px -3px rgba(220, 38, 38, 0.2)'
          : '0 4px 6px -1px rgba(220, 38, 38, 0.1)'
      }}
    >
      <span className="relative flex items-center">
        <span>Lej Pølsevogn</span>
        <motion.span
          className="ml-2"
          animate={{ y: [0, -2, 0] }}
          transition={{
            duration: 1,
            repeat: Infinity,
            repeatType: "reverse"
          }}
        >
          <FaTruck className="w-4 h-4" />
        </motion.span>
      </span>
    </Link>
  );
}